import { styled } from 'styled-components';
import partition from 'lodash/partition';
import type { JSX } from 'react';
import type { SpeakerType } from '~/components/SpeakerBios/Speaker';
import { Speaker } from '~/components/SpeakerBios/Speaker';
import type { SpeakerBioGridItemStyleStrategy } from './components/SpeakerBioStyles';

const Grid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  width: 100%;
`;

type Props = {
  speakers: SpeakerType[];
  styleStrategy?: SpeakerBioGridItemStyleStrategy;
};

export const SpeakersGrid = ({ speakers, styleStrategy }: Props): JSX.Element | null => {
  if (speakers.length === 0) {
    return null;
  }

  const [hosts, panelists] = partition(speakers, ({ role }) => role === 'host');

  return (
    <Grid>
      {hosts
        .sort((speaker1, speaker2) => speaker1.rowOrder - speaker2.rowOrder)
        .map((speaker) => (
          <Speaker
            key={speaker.id}
            speaker={speaker}
            styleStrategy={styleStrategy}
          />
        ))}
      {panelists
        .sort((speaker1, speaker2) => speaker1.rowOrder - speaker2.rowOrder)
        .map((speaker) => (
          <Speaker
            key={speaker.id}
            speaker={speaker}
            styleStrategy={styleStrategy}
          />
        ))}
    </Grid>
  );
};
